<div *ngIf="this.userDontHaveValidation" class="default-space-between-components">
    <mat-card (click)="goToValidation()">
        <mat-card-content class="warning-validation-requeried-banner">
            <div class="alert-message">
                <mat-icon>info_one</mat-icon>
                <p>{{ 'alert_validation_required_message' | translate }}</p>
            </div>
            <mat-icon>chevron_right</mat-icon>
        </mat-card-content>
    </mat-card>
</div>